import { Container, Row, Col, Image } from 'react-bootstrap';
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewSearch,
    ReviewSerchBox,
    ReviewRightSection,
    LeftQuote,
    RightQuote,
    RightBanner,
    BannerBlueWrapper,
    BannerBlueTitle,
    BannerBlueText,
    BadgeSmallText,
} from "../../components/common/commonSubBanner/commonSubBannerStyle";

import BadgeCheckBox from "../../components/common/badgeCheckBox";
import ReviewImage from "../../assests/images/top-banner-image/review-your-favorite-nonprofits.webp";
import QuoteIcon from "../../assests/images/quoteicon.svg";
import MetaComponent from "../../components/common/metaComponent";
import SearchBox from '../../components/common/searchBox/searchBox';

const WriteReview = () => {
    return (
        <>
            <MetaComponent
                keywords=""
                description="Write reviews for nonprofits such as museums, animal shelters, and youth programs on GreatNonprofits. Share your stories and support meaningful causes."
                ogTitle="Write Reviews for Nonprofits and Charities on GreatNonprofits"
                ogDescription="Write reviews for nonprofits such as museums, animal shelters, and youth programs on GreatNonprofits. Share your stories and support meaningful causes."
                ogUrl="https://new.greatnonprofits.org/write-review"
                ogImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                twitterTitle="Write Reviews for Nonprofits and Charities on GreatNonprofits"
                twitterDescription="Write reviews for nonprofits such as museums, animal shelters, and youth programs on GreatNonprofits. Share your stories and support meaningful causes."
                twitterUrl="https://new.greatnonprofits.org/write-review"
                twitterImage="https://cdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
                canonicalUrl="https://www.greatnonprofits.org/write-review"
            />
            <WriteReviewSection>
                <Container className="cont-w">
                    <Row>
                        <Col lg={6} sm={12} md={12}>
                            <Title className="write-review-text">Help Others Learn About A Nonprofit!</Title>
                            <ReviewText>Review nonprofits such as museums, animal shelters, youth programs and more! </ReviewText>
                            <ReviewText>After you've posted your review, you'll be able to quickly turn your story into a fundraiser to amplify your impact.</ReviewText>

                            <ReviewSearch className='write-review-select-box'>

                                <ReviewSerchBox>
                                    <SearchBox />
                                    {/* <Form className="search-header" onSubmit={formik.handleSubmit}>
                                    <SearchInputBox>
                                        <InputGroup>
                                            <InputGroupIcon>
                                                <Image src={Search_icon} width="20px" height="20px" className="search-group-icon" />
                                            </InputGroupIcon>
                                            <FormControl type="text"
                                                placeholder="Org,City & State"
                                                id="location"
                                                maxLength={30}
                                                name="location"
                                                value={formik.values.location}
                                                onChange={formik.handleChange} />
                                            {formik.touched.location && formik.errors.location && (
                                                <div className="error">
                                                    <p>{formik.errors.location}</p>
                                                </div>
                                            )}
                                        </InputGroup>
                                        <InputGroup className="zipcode">
                                            <FormControl type="number"
                                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                placeholder="Zip Code"
                                                maxLength={10}
                                                name="zipcode"
                                                value={formik.values.zipcode}
                                                onChange={formik.handleChange} />
                                            {formik.touched.zipcode && formik.errors.zipcode && (
                                                <div className="error">
                                                    <p>{formik.errors.zipcode}</p>
                                                </div>
                                            )}
                                        </InputGroup>
                                    </SearchInputBox>
                                    <Button variant="outline-success" type="submit">Search</Button>
                                </Form> */}
                                </ReviewSerchBox>
                            </ReviewSearch>
                            <BannerBlueWrapper className="blue-banner">
                                <BannerBlueTitle>Contact GreatNonprofits</BannerBlueTitle>
                                <BannerBlueText>Monday to Friday, 8am to 4pm PST</BannerBlueText>
                            </BannerBlueWrapper>

                            <BadgeSmallText className="base-small-text">Add a Logo Badge to Your Website</BadgeSmallText>
                            <BadgeCheckBox setColor={() => { }} />
                        </Col>
                        <Col lg={6} sm={12} md={12}>
                            <RightBanner className="left_banner">
                                <ReviewRightSection>
                                    <LeftQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</LeftQuote>
                                    <Image src={ReviewImage} alt="ReviewImage" />
                                    <RightQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</RightQuote>
                                </ReviewRightSection>
                            </RightBanner>
                        </Col>
                    </Row>
                </Container>

            </WriteReviewSection>
        </>
    )
};
export default WriteReview;